import { DateTime, Interval } from "luxon";
/**
 * Validates an interval and returns it as a valid interval with start and end
 *
 * @param interval The interval to validate
 * @return The validated interval in a wrapper object
 */
export function validateInterval(interval) {
    if (!interval.isValid || !interval.start || !interval.end) {
        return { valid: false, interval: undefined };
    }
    return {
        valid: true,
        interval: interval,
    };
}
export function dateTimeFromSomething(something) {
    if (something == null) {
        return something;
    }
    let dateTime = null;
    switch (typeof something) {
        case "string": {
            dateTime = DateTime.fromISO(something);
            break;
        }
        case "number": {
            dateTime = DateTime.fromMillis(something);
            break;
        }
        case "object": {
            dateTime =
                something instanceof Date
                    ? DateTime.fromJSDate(something)
                    : DateTime.isDateTime(something)
                        ? something
                        : DateTime.invalid("Invalid input type for dateTimeFromSomething");
            break;
        }
        default: {
            dateTime = DateTime.invalid("Invalid input type for dateTimeFromSomething");
            break;
        }
    }
    return dateTime.isValid ? dateTime : null;
}
export function intervalFromSomething(something) {
    if (something == null) {
        return something;
    }
    let interval = null;
    if (typeof something === "string") {
        return Interval.fromISO(something);
    }
    else if (typeof something === "object") {
        const start = dateTimeFromSomething(something.start);
        const end = dateTimeFromSomething(something.end);
        interval = Interval.fromDateTimes(start, end);
    }
    return interval;
}
//# sourceMappingURL=intervalTools.js.map